import React from "react";
var __jsx = React.createElement;
import ContactForm from "./Components/ContactForm/ContactForm";
import ContactMap from "./Components/ContactMap/ContactMap";
import AnyQustV2 from "@/pages/homePageV2/homePageComponents/components/AnyQust/AnyQustV2";
import stl from "./ContactComponent.module.css";
var ContactComponent = function ContactComponent() {
  return /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.contactSection].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement(ContactForm, null), /*#__PURE__*/React.createElement(ContactMap, null)), /*#__PURE__*/React.createElement("div", {
    className: stl.anyQustWrapper
  }, /*#__PURE__*/React.createElement(AnyQustV2, {
    isContactUs: true,
    hasSocialLinks: true
  })));
};
export default ContactComponent;